import React from 'react';
import { Card, Modal, Button } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { updateRequestProperties, submitData } from 'modules/userrequest';

import PricesForm from './PricesForm';

export class Prices extends React.Component {
  state = {
    visible: false,
    pricing: {},
  };

  setPricing = pricing => this.setState({ pricing });

  setClosed = () => {
    const { userrequest: { properties: { pricing = {} } } } = this.props;

    this.setState({
      visible: false,
      pricing,
    });

    // Remove the modal from dom force a re-render of PricesForm
    // and make it easy to reset initialValue
    setTimeout(() => this.setState({ displayModal: false }), 300);
  };

  openModal = () => {
    const { userrequest: { properties: { pricing = {} } } } = this.props;

    this.setState({
      visible: true,
      displayModal: true,
      pricing,
    });
  };

  saveForm = () => {
    const { userrequest } = this.props;
    const { pricing } = this.state;
    const newProperties = {
      ...userrequest.properties,
      pricing,
    };

    this.props.updateRequestProperties(newProperties);

    this.props.submitData({
      data: {
        ...userrequest,
        properties: newProperties,
      },
      state: userrequest.state,
    });

    this.setClosed();
  }

  render () {
    const { visible, pricing, displayModal } = this.state;
    const { openModal, setClosed, setPricing, saveForm } = this;

    return (
      <Card
        className="no-print"
        title="Tarification"
      >
        <Button
          onClick={openModal}
        >
          Indiquer les tarifs
        </Button>
        {displayModal && (
          <Modal
            title="Tarification"
            visible={visible}
            onOk={saveForm}
            onCancel={setClosed}
          >
            <PricesForm
              initialValue={pricing}
              onChange={setPricing}
            />
          </Modal>
        )}
      </Card>
    );
  }
}

const mapStateToProps = state => ({
  userrequest: state.userrequest,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({
    updateRequestProperties,
    submitData,
  }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Prices);



// WEBPACK FOOTER //
// ./src/components/Userrequest/Prices.js